import { Spinner } from '@oysterjs/ui/spinner';

/**
 * Loading placeholder shown while a library list page's deferred loader is
 * still resolving. Visual matches the empty-state card so the layout doesn't
 * jump when results arrive. Pages pass their own noun (e.g. "Loading
 * styles…") via `title`.
 */
export function LibraryListLoading(props: {
  title: string;
  /** Drops the card chrome, for use inside a card that already has it. */
  embedded?: boolean;
}) {
  return (
    <div
      role="status"
      className={props.embedded ? 'px-6' : 'rounded-lg bg-white px-6 shadow dark:bg-neutral-800'}
    >
      <div className="text-center py-12">
        <Spinner size="size-8" color="neutral" />
        <h3 className="mt-2 text-sm font-semibold text-neutral-900 dark:text-white">
          {props.title}
        </h3>
        <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
          This might take a moment.
        </p>
      </div>
    </div>
  );
}
